import { useAppSelector } from '@/hooks/useAppSelector';
import { useTimer } from '@/hooks/useTimer';
import { FunctionComponent } from 'react';
import { reservationEndTimeSelector } from '@/store/selectors/reservation';

export const Timer: FunctionComponent = () => {
  const reservationEndTime = useAppSelector(reservationEndTimeSelector);
  const timeLeft = useTimer({
    unixDeadline: reservationEndTime,
  });

  const mmss = new Date(timeLeft).toISOString().slice(14, 19);

  return (
    <div className="header__timer">
      <i className="icon-schedule" />
      <strong>{mmss}</strong>
    </div>
  );
};
